import * as React from 'react';
import * as PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { RatingBanner } from '../../components/RatingBanner';
import { getRegion } from '../../selectors/filters/getRegion';
import { getUrlById } from '../TitleContainer/utils';

export const RatingBannerContainer: React.FunctionComponent = (_props, { config }) => {
  const { id } = useSelector(getRegion, shallowEqual);
  const deviceType = useDeviceType();
  const href = getUrlById(id, config);

  if (deviceType !== 'phone' || !href) {
    return null;
  }

  return <RatingBanner href={href} />;
};

RatingBannerContainer.contextTypes = {
  config: PropTypes.object,
};
